module.exports = __webpack_public_path__ + "img/bg-DetailCard.8346b5e8.png";